// eslint-disable-next-line import/no-unresolved
import * as LucideIcons from 'lucide-react';

const toPascalCase = (kebab) => kebab
  .split('-')
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join('');

const toKebabCase = (pascal) => pascal
  .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
  .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
  .toLowerCase();

// Shown for a habit with no icon of its own: "check circle broken" from the UI Icon Library.
const DEFAULT_HABIT_ICON = LucideIcons.CircleCheckBig;

const iconComponentCache = {};
const ICON_CATALOG_STORAGE_PATH = 'habits/icon-catalog.v1.json';
const EXCLUDED_LUCIDE_EXPORTS = new Set([
  'Icon',
  'LucideIcon',
  'IconNode',
  'createLucideIcon',
]);

const isLucideComponentExport = (exportName) => /^[A-Z]/.test(exportName)
  && !exportName.endsWith('Icon')
  && !EXCLUDED_LUCIDE_EXPORTS.has(exportName)
  && Boolean(LucideIcons[exportName]?.$$typeof);

const allHabitIconIds = Object.keys(LucideIcons)
  .filter(isLucideComponentExport)
  .map((exportName) => toKebabCase(exportName))
  .sort();

export const getIconComponent = (iconId) => {
  if (!iconId) {
    return DEFAULT_HABIT_ICON;
  }
  if (iconComponentCache[iconId]) {
    return iconComponentCache[iconId];
  }
  const component = LucideIcons[toPascalCase(iconId)] ?? DEFAULT_HABIT_ICON;
  iconComponentCache[iconId] = component;
  return component;
};

export const getFallbackIconIds = () => [...allHabitIconIds];

export const refreshIconCatalog = async (firebase) => {
  try {
    const storage = firebase?.storage;
    if (!storage?.ref) {
      return null;
    }

    const downloadUrl = await storage.ref().child(ICON_CATALOG_STORAGE_PATH).getDownloadURL();
    const response = await fetch(downloadUrl);
    if (!response.ok) {
      return null;
    }

    const iconCatalog = await response.json();
    if (!Array.isArray(iconCatalog?.icons) || iconCatalog.icons.length === 0) {
      return null;
    }

    return iconCatalog;
  } catch {
    return null;
  }
};
